module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Motivo de Perda")]), _vm._m(0), _c('br'), _c('br'), _c('new-lost-reason', {
    on: {
      "created": _vm.createdLostReason
    }
  }), _c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "table-body"
  }, [_c('hr'), _vm._l((_vm.$store.getters.lostReasonsList), function(lost_reason) {
    return _c('list-item', {
      key: lost_reason.id,
      attrs: {
        "lost_reason": lost_reason
      },
      on: {
        "updated": _vm.updatedLostReason,
        "destroy": _vm.openDestroyConfirmationModal
      }
    })
  })], 2)]), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('loading', {
    attrs: {
      "loading": _vm.$store.getters.lostReasonLoading
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$store.getters.lostReasonLoading),
      expression: "!$store.getters.lostReasonLoading"
    }],
    staticClass: "light-gray-text light-text"
  }, [_vm._v("Sem mais resultados")])], 1), _c('confirm-modal', {
    attrs: {
      "id": "confirm-destroy-lost-reason",
      "title": "Excluir motivo de perda",
      "confirm_text": "Sim, excluir",
      "confirm_class": "btn-danger"
    },
    on: {
      "confirm-modal-confirm": _vm.destroyLostReason
    }
  }, [_c('br'), _c('div', {
    staticClass: "text-center"
  }, [_c('div', [_vm._v("Confirma exclusão do motivo de perda abaixo?")]), _c('br'), _c('strong', {
    staticClass: "dark-red-color"
  }, [_vm._v(_vm._s(_vm.selected_lost_reason.title))]), _c('br'), _c('br')])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "light-gray-text light-text"
  }, [_vm._v("Cadastre motivos de perda que serão atribuídos aos contatos marcados com o estágio 'Perdido'. Ex.: Falta de budget"), _c('br'), _vm._v("Os motivos de perda cadastrados aqui estarão disponíveis para todo o time de vendas.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0eb999a6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/lost_reason/index.vue
// module id = 1015
// module chunks = 1